<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent1"><a id="page_iv"></a><a id="fm01"></a>A<span class="small">LSO BY</span> F<span class="small">RANCES</span> I<span class="small">TANI</span></p>
<p class="noindent1"><span class="small">FICTION</span></p>
<p class="indent"><em>Poached Egg on Toast</em></p>
<p class="indent"><em>Deafening</em></p>
<p class="indent"><em>Leaning, Leaning Over Water</em></p>
<p class="indent"><em>Man Without Face</em></p>
<p class="indent"><em>Pack Ice</em></p>
<p class="indent"><em>Truth or Lies</em></p>
<p class="noindent1"><span class="small">POETRY</span></p>
<p class="indent"><em>A Season of Mourning</em></p>
<p class="indent"><em>Rentee Bay</em></p>
<p class="indent"><em>No Other Lodgings</em></p>
<p class="noindent1"><span class="small">CHILDREN’S</span></p>
<p class="indent"><em>Linger by the Sea</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?1941a581